/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Snap_To_Event_Start_DescInputs */



/**
* | output |
* | --- |
* | "Snap event ends times to the start of the next event when within 0.5 seconds" |
*
* @param {Snap_To_Event_Start_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const snap_to_event_start_desc = /** @type {((inputs?: Snap_To_Event_Start_DescInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Snap_To_Event_Start_DescInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aligner la fin des événements sur le début du suivant dans un rayon de 0,5 secondes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Snap-Ereignisse beenden die Zeit bis zum Beginn des nächsten Ereignisses, wenn diese innerhalb von 0,5 Sekunden liegt.")
	if (locale === "it") return /** @type {LocalizedString} */ ("L'evento Snap termina all'inizio dell'evento successivo quando entro 0,5 secondi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Время завершения события Snap истекает, когда до начала следующего события остается менее 0,5 секунды.")
	if (locale === "es") return /** @type {LocalizedString} */ ("El evento Snap finaliza a tiempo hasta el inicio del siguiente evento cuando está dentro de 0,5 segundos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("快照事件结束到下一个事件开始的时间差在 0.5 秒以内")
	if (locale === "ja") return /** @type {LocalizedString} */ ("0.5秒以内の場合、次のイベントの開始時刻にスナップイベントの終了時刻を設定します。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्नैप इवेंट के समाप्त होने का समय अगले इवेंट के शुरू होने के समय से 0.5 सेकंड के भीतर होता है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("O intervalo entre o término do evento e o início do próximo evento é de 0,5 segundos.")
	return /** @type {LocalizedString} */ ("Snap event ends times to the start of the next event when within 0.5 seconds")
});